import { Button, Grid, Group, Modal, NativeSelect, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

const BannerBlockCopyModal = ({ bannerBlock: passedBannerBlock, show, save, close }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();
  const [pages, setPages] = useState();
  const [error, setError] = useState();
  const [bannerBlock, setBannerBlock] = useState({
    ...passedBannerBlock,
    id: null,
    name: `${passedBannerBlock.name} Copy`,
  });

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages`)
      .then(({ pages }) => {
        setPages(pages);
      })
      .catch(setError);
  }, [accountId, domainId, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  const submitForm = (e) => {
    e.preventDefault();
    save(bannerBlock);
  };

  let pageOptions = [{ value: '', label: '' }];

  if (pages) {
    pageOptions = [
      { value: '', label: '' },
      ...pages.map((page) => ({
        value: page.id.toString(),
        label: page.name,
      })),
    ];
  }

  return (
    <Modal opened={show} onClose={() => close()} title="Copy Banner Block">
      <form onSubmit={(e) => submitForm(e)}>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>
              Page
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <NativeSelect
              name="pageId"
              data={pageOptions}
              value={bannerBlock.pageId || ''}
              onChange={({ target }) => setBannerBlock({ ...bannerBlock, pageId: target.value })}
            />
          </Grid.Col>
        </Grid>
        <Group justify="flex-end" gap="xs" py="md">
          <Button variant="default" onClick={() => close()}>
            Close
          </Button>
          <Button type="submit" disabled={!bannerBlock.pageId}>
            Make a copy
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default BannerBlockCopyModal;
